import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_syb",
  "use": "icon-home_syb-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-home_syb\">\n  <rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\" />\n  <line x1=\"16\" y1=\"3\" x2=\"16\" y2=\"7\" />\n  <line x1=\"8\" y1=\"3\" x2=\"8\" y2=\"7\" />\n  <line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\" />\n  <path d=\"M3 15h18\" />\n  <path d=\"M8 15v3a2 2 0 0 0 4 0v-3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol